import type { NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';

import FullViewRvImage from '@/assets/group-rv-bookings/lake-dock-pink-sunset.jpg';
import CulturalImage from '@/assets/group-rv-bookings/music-festival-aerial.jpg';
import ContainerImage from '@/assets/group-rv-bookings/trailer-park-rows.jpg';
import HeroImageWeddings from '@/assets/group-rv-bookings/wedding-ceremony-lakeside.jpg';
import SmallViewImage from '@/assets/group-rv-bookings/wyldwood-ranch-sign.jpg';
import { GroupRvEnquiryForm } from '@/components/route/group-rv-bookings/EnquiryForm';
import { GroupRvFaqs } from '@/components/route/group-rv-bookings/FAQs';
import { GroupRvHero } from '@/components/route/group-rv-bookings/Hero';
import { GroupRvHowItWorks } from '@/components/route/group-rv-bookings/HowItWorks';
import { GroupRvTestimonial } from '@/components/route/group-rv-bookings/Testimonial';
import {
  DEFAULT_WHY_RV_CARDS,
  getWhyRvCardByKey,
  GroupRvWhyRVs,
  SOCCER_CARD,
  TWhyRvCard,
} from '@/components/route/group-rv-bookings/WhyRVs';
import HeadMeta from '@/components/static-pages/HeadMeta';

const GroupRvCulturalEventsPage: NextPage = () => {
  const intl = useIntl();

  // Reuse the same SEO copy as the main group bookings page for now.
  const title = intl.formatMessage({
    id: 'QH+v06',
    defaultMessage: 'Group RV Rentals for events has never been easier.',
    description: 'Group bookings landing page SEO title',
  });

  const description = intl.formatMessage({
    id: 'YuHfzS',
    defaultMessage:
      "Need 5+ RVs for groups to stay on-site during events? We're your dedicated, stress-free concierge service.",
    description: 'Group bookings landing page SEO description',
  });

  return (
    <>
      <HeadMeta title={title} description={description} />

      <main>
        {/* Hero */}
        <GroupRvHero
          eyebrow="Booking multiple RVs made easy."
          headline="Group RV Rentals for events has never been easier."
          body={
            <>
              Need 5+ RVs for groups to stay on-site during events?
              <br />
              We&apos;re your dedicated, stress-free concierge service.
            </>
          }
          images={[CulturalImage, ContainerImage]}
        />

        {/* How it works */}
        <GroupRvHowItWorks />

        {/* Enquiry form (scroll target for CTAs above) */}
        <GroupRvEnquiryForm page="cultural-events" />

        {/* Testimonial */}
        <GroupRvTestimonial
          templateType="SubPage"
          subPageKey="cultural-coordinator"
          subPageImages={{ primary: FullViewRvImage, secondary: SmallViewImage }}
        />

        {/* FAQs */}
        <GroupRvFaqs />

        {/* Why RVs section */}
        <GroupRvWhyRVs
          heading="Interested in booking RVs for other types of events? "
          color={true}
          cards={[
            {
              ...getWhyRvCardByKey('weddings'),
              image: HeroImageWeddings as unknown as { src: string },
            } as TWhyRvCard,
            SOCCER_CARD,
            ...DEFAULT_WHY_RV_CARDS.filter(
              card => card.key !== 'weddings' && card.key !== 'cultural-events',
            ),
          ]}
        />
      </main>
    </>
  );
};

export default GroupRvCulturalEventsPage;
